// extracted by css-extract-rspack-plugin
export default {"root":"root-r2VTpz","label":"label-wwGrTX","input":"input-HDxspu"};